<template>
  <div class="flex flex-col overflow-hidden h-full">

    <!-- Navbar -->
    <div v-show="showNavbar">
      <Navbar/>
    </div>

    <!-- Main Document Area -->
    <main class="flex flex-row flex-1 overflow-hidden bg-blue-100">


      <section class="document-area flex flex-col w-full overflow-y-auto">

        <slot>
          <router-view name="default"/>
        </slot>
      </section>
    </main>

    <!-- Footer -->
    <footer class="flex fixed bottom-0 p-2 w-full bg-gray-900 z-10" style="min-height: 41px">
      <div v-if="shouldShowPoweredBy" class="flex items-center">
        <span class="text-sm text-gray-500 dark:text-gray-400">Powered by</span>
        <v-img height="25" max-width="100" src="https://fleetwire.twic.pics/wp-image/2024/12/Logo-Main-copyTransparent.png?twic=v1/resize=100" width="100"/>
      </div>
      <div class="text-sm flex-grow"></div>
    </footer>
  </div>
</template>

<script lang="ts" setup>
import {computed} from 'vue';
import Navbar from '@/components/eSigner/NavBar.vue';
import {useESign} from '@/composables/useESign';
import {useRoute} from 'vue-router';
import {useEnvelope} from '@/composables/useEnvelope';

const {envelope} = useESign();
const {envelopeIsReady} = useEnvelope();
const route = useRoute();

// Determines whether the envelope is white-labeled
const envelopeIsWhiteLabeled = computed(() => envelopeIsReady.value && (envelope.value?.white_label ?? false));

// Determines if "Powered by" should be shown
const shouldShowPoweredBy = computed(() => envelopeIsReady.value && !envelopeIsWhiteLabeled.value);

// Determines whether to show the navbar
const showNavbar = computed(() => {
  console.log('Route meta:', route.meta);
  return route.meta?.showNavbar ?? true;
});
</script>

<style lang="scss">
.powered-by {
  display: inline-block;
  zoom: 1;
  position: relative;
  top: 1px;
  color: #b9b9b9;
  font-size: 12px;
  margin-right: 2px;
  line-height: normal;
}
</style>
